module.exports = __webpack_public_path__ + "img/copy_element.e95174f1.png";